<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <div class="block">
                <p class="title">热区模块</p>
                <div class="tabs is-toggl">
                    <ul class="">
                        <li class="is-active" >
                            <a><span>内容管理</span></a>
                        </li>
                    </ul>
                </div>
                    <div class="hotmap-list-container">
                            <div class="fleft">
                                <el-button type="success" @click='addHotAd'>新增</el-button>
                            </div>
                            <div v-if="count > 0" class="clearfix fright" style="margin-bottom: 20px;">
                                <el-pagination
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-size="pageSize"
                                        layout="total, prev, pager, next, jumper"
                                        :total="count">
                                </el-pagination>
                            </div>
                            <table class="table is-bordered">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>图片</th>
                                    <th>标题以及访问量</th>
                                    <th>状态</th>
                                    <th>排序号</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="list-cell" v-for="(item, index) in hotMapList">
                                    <td>
                                        {{item.advId}}
                                        <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
                                        <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
                                        <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
                                        <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
                                    </td>
                                    <td>
                                        <image-component v-if="typeof item.image == 'string'" :image="JSON.parse(item.image)" :width='200'></image-component>
                                        <image-component v-else :image="item.image" :width='200'></image-component>
                                    </td>
                                    <td>
                                        <p class="content-title title">标题:{{item.title}}</p>
                                        <p class="white-space" v-if='item.stats'>访问量:{{item.stats}}</p>
                                    </td>
                                    <td>
                                        <div class="time" v-if="item.status==0">
                                            <div v-if="item.startTime||item.endTime">
                                                {{item.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}} ~ {{item.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}}
                                            </div>
                                            <div v-else>永久开启</div>
                                        </div>
                                        <div v-if="item.status==1">永久关闭</div>
                                    </td>
                                    <td>
                                        <div class="sort-wrap">排序号</br>
                                            <input class="input width-1" v-model="item.sort" @change="sort(item.advId, item.sort)">
                                        </div>
                                    </td>
                                    <td>
                                        <p class='button-wrap'>
                                            <el-button type="success" @click="goEdit(item)">编辑</el-button>
                                        </p>
                                        <p>
                                            <el-button type="danger" @click="deleteModuleContent(item.advId, index)">删除</el-button>
                                        </p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-if="count > 0" class="clearfix fright">
                                <el-pagination
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-size="pageSize"
                                        layout="total, prev, pager, next, jumper"
                                        :total="count">
                                </el-pagination>
                            </div>
                        </div>
            </div>
        </article>
    </div>
</template>

<script type="text/babel">

    export default {
        data() {
            return {
                hotMapList: [],
                count: 0,
                currentPage: 1,
                pageSize: 20,

            }
        },
        mounted() {
            this.getModuleList()

        },
        methods: {
            sort(advId, sort) {
                let params = {
                    advId: advId,
                    sort: sort
                }
                HttpRequest.get("/admin.php?method=advertisementofmine.setSort", params).then((response) => {
                    if (!response.result) {
                        this.$message('保存成功')
                    }else{
                        this.$message(response.data.msg)
                    }
                })
            },
            getModuleList() {
                if (true) {
                    let params = {
                        page: this.currentPage,
                        pageSize: this.pageSize
                    }
                    HttpRequest.get("/admin.php?method=advertisementofmine.getMyAdvertisementList", params).then((response) => {
                        this.count = response.data.count
                        if (response && response.data && response.data.list) {
                            this.hotMapList = response.data.list
                        } else {
                            this.hotMapList = []
                        }
                    })
                }
            },
            handleCurrentChange(page) {
                if(this.currentPage!==page){
                    this.currentPage=page;
                    this.getModuleList()
                }
            },
            addHotAd() {
                this.$router.push({
                    name: 'hotAdEdit',
                    query: {}
                })
            },
            goEdit(item) {
                this.$router.push({
                    name: 'hotAdEdit',
                    query: { advId: item.advId,page: this.currentPage }
                })
            },
            deleteModuleContent(advId, index) {
                let params = {
                    advId: advId
                }
                if (confirm('确定删除?')) {
                    HttpRequest.get("/admin.php?method=advertisementofmine.remove", params).then((response) => {
                        if (response.data.result) {
                            this.hotMapList.splice(index, 1);
                            this.count--;
                        }
                    })
                }
            },
        },
    }

</script>

<style lang="less" scoped>
    .hotmap-list-container {
        .list-cell{
            .title{
                margin-bottom: 20px;
                padding: 0;
            }
            .time{
                margin-bottom: 20px;
                width: 150px;
                white-space: normal;
            }

        }
        .button-wrap {
            margin-bottom: 10px;
        }
    }

    .custom-link-wrap{
        border-radius: 6px;
        border: 1px solid #00d1b2;
        width: 300px;
        padding: 20px;
    }
    .margin-top-left-20{
        margin: 20px 0 0 20px;
    }
    .slider-wrap{
        width: 400px;
        margin-top: 40px;
        .tooltip-value{
            margin-left: 20px;
        }
        .input-slider{
            margin-top: 30px;
        }
    }
    .content-title{
        white-space: normal;
        line-height: 1.2;
        display: inline-block;
    }
    .cursor-point {
        cursor: pointer;
    }
</style>
